export class NavigationLink {
  labelKey: string;
  link: string;
}
